export interface ICopyUsableValues {
    [key: string]: any;
}

export const copyUsableValues = (source: ICopyUsableValues, target: ICopyUsableValues) => {
    Object.keys(source).forEach(key => {
        if (source[key] !== null && source[key] !== undefined) {
            target[key] = source[key];
        }
    });
};
